// extracted by mini-css-extract-plugin
export default {"wrap":"LanguageSelect_wrap__ljGB1","icon":"LanguageSelect_icon__ZFVnI","iconCompact":"LanguageSelect_iconCompact__AnFy7"};